import getConfig from 'next/config';

import { AVAILABLE_COOKIES, createCookieApi } from '@tgg/util';

import { LocalConfig } from 'apps/commerce/next.config.types';

import { GymsVisitHistoryCookie } from './cookies.types';

const {
    publicRuntimeConfig: { APP_ENVIRONMENT },
}: LocalConfig = getConfig();

export const createGymsVisitHistoryCookieApi = () =>
    createCookieApi<GymsVisitHistoryCookie>(
        'commerce',
        AVAILABLE_COOKIES.GYMS_VISIT_HISTORY,
        {},
        {
            expires: 60, // 60 days - When cookie is expired, the browser should take care of cookie cleanup.
            sameSite: 'strict',
            secure: true,
        },
        APP_ENVIRONMENT,
    );

export const GymsVisitHistoryCookieApi = createGymsVisitHistoryCookieApi();

export const updateGymsVisitHistoryCookie =
    GymsVisitHistoryCookieApi.browser.setCookie;

export const getGymsVisitHistoryCookie =
    GymsVisitHistoryCookieApi.browser.getCookie;

export const deleteGymsVisitHistoryCookie =
    GymsVisitHistoryCookieApi.browser.deleteCookie;
